export interface AnchorConfig {
    element: HTMLElement;
}

export class Anchor {
    private readonly element: HTMLElement;

    constructor({element}: AnchorConfig) {
        this.element = element;
        this.init();
    }

    public scroll(evt: Event): void {
        const url = this.element.getAttribute('href');

        if (url && url.substring(0, 1) === `#` && url.length > 1) {
            evt.preventDefault();
            const target = document.querySelector(url);

            if (!target) return;
            target.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }

    protected init(): void {
        if (!this.element) return;
        this.element.addEventListener('click', (evt) => this.scroll(evt));
    }
}